import React from "react";
import styles from "./AudioEditorLoader.module.css";

interface AudioEditorLoaderPickerProps {
    title?: string;
    helpText?: string;
    onClick: () => void;
}

const AudioEditorLoaderPicker: React.FC<AudioEditorLoaderPickerProps> = ({ title, helpText, onClick }) => {
    return (
        <div className={styles.pickerContainer}>
            {title && <h3 className={styles.pickerTitle}>{title}</h3>}
            <button type="button" className={styles.pickerBox} onClick={onClick}>
                <span className={styles.pickerPlus} aria-hidden>
                    +
                </span>
                {helpText && <span className={styles.pickerHelpText}>{helpText}</span>}
            </button>
        </div>
    );
};

export default AudioEditorLoaderPicker;
